import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-gray-900';
  };
  
  return (
    <nav className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="text-xl font-bold text-gray-900">
            Mastermind Manager
          </Link>
          
          <div className="flex space-x-8">
            <Link 
              to="/" 
              className={`px-3 py-2 text-sm font-medium ${isActive('/')}`}
            >
              Dashboard
            </Link>
            <Link 
              to="/groups" 
              className={`px-3 py-2 text-sm font-medium ${isActive('/groups')}`}
            >
              Groups
            </Link>
            <Link 
              to="/hotseats" 
              className={`px-3 py-2 text-sm font-medium ${isActive('/hotseats')}`}
            >
              Hotseats
            </Link>
            <Link 
              to="/goals" 
              className={`px-3 py-2 text-sm font-medium ${isActive('/goals')}`}
            >
              Goals
            </Link>
            <Link 
              to="/analytics" 
              className={`px-3 py-2 text-sm font-medium ${isActive('/analytics')}`}
            >
              Analytics
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;